<template>
  <footer class="site-footer">
    <div class="site-footer__inner">
      <div class="site-footer__grid">

        <!-- Col 1: Brand -->
        <div class="site-footer__brand">
          <h3>LET'S MAKE<br />IT HAPPEN.</h3>
          <p>Crafting Digital Experiences with Emerging Tech (AI, IoT, XR)</p>
        </div>

        <!-- Col 2: Quick Links -->
        <div class="site-footer__col">
          <h4>Quick Links</h4>
          <ul>
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/workpage">Work</router-link></li>
            <li><router-link to="/researchpage">Research</router-link></li>
            <li><router-link to="/mentorshippage">Mentorship</router-link></li>
            <li><router-link to="/blogpage">Blog</router-link></li>
          </ul>
        </div>

        <!-- Col 3: Social Media -->
        <div class="site-footer__col">
          <h4>Social Media</h4>
          <div class="site-footer__socials">
            <a href="https://www.linkedin.com/in/ravindra-bachate-ph-d-715388179/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i class="fab fa-linkedin-in"></i>
            </a>
            <a href="https://www.instagram.com/ravindrabachate/" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="https://github.com/ravindrabachate" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <i class="fab fa-github"></i>
            </a>
          </div>
        </div>

        <!-- Col 4: Contact -->
        <div class="site-footer__col">
          <h4>Contact</h4>
          <a href="mailto:bachateravi@gmail.com" class="site-footer__email">
            <i class="fas fa-envelope"></i> bachateravi@gmail.com
          </a>
        </div>

      </div>

      <!-- Bottom bar -->
      <div class="site-footer__bottom">
        <span>©2025 RAVINDRA BACHATE, All Rights Reserved.</span>
        <span>Made with <span class="heart">♥</span> by Ravindra Bachate</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterPage',
};
</script>

<style scoped>
.site-footer {
  background: var(--color-bg-darker);
  color: var(--color-bg-white);
  padding: var(--space-16) var(--space-6) 0;
}
.site-footer__inner {
  max-width: var(--container-xl);
  margin: 0 auto;
}

/* 4-column grid */
.site-footer__grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: var(--space-12);
  padding-bottom: var(--space-12);
}

/* Brand column */
.site-footer__brand h3 {
  font-size: var(--text-xl);
  font-weight: var(--font-extrabold);
  color: var(--color-bg-white);
  line-height: var(--leading-tight);
  margin: 0 0 0.75rem;
}
.site-footer__brand p {
  font-size: var(--text-sm);
  color: var(--color-text-300);
  line-height: var(--leading-relaxed);
  margin: 0;
}

/* Regular columns */
.site-footer__col h4 {
  font-size: var(--text-sm);
  font-weight: var(--font-semibold);
  color: var(--color-bg-white);
  margin: 0 0 var(--space-4);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wider);
}
.site-footer__col ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
.site-footer__col ul li a,
.site-footer__col a {
  color: var(--color-text-300);
  text-decoration: none;
  font-size: var(--text-sm);
  transition: color var(--duration-base) var(--ease-out);
}
.site-footer__col ul li a:hover,
.site-footer__col a:hover {
  color: var(--color-primary);
}

/* Social icons */
.site-footer__socials {
  display: flex;
  gap: 0.6rem;
}
.site-footer__socials a {
  width: 36px;
  height: 36px;
  background: var(--color-bg-dark);
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-300);
  font-size: var(--text-sm);
  text-decoration: none;
  transition: background var(--duration-base) var(--ease-out), color var(--duration-base) var(--ease-out);
}
.site-footer__socials a:hover {
  background: var(--color-primary);
  color: var(--color-bg-white);
}

/* Email link */
.site-footer__email {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: var(--color-text-300);
  font-size: var(--text-sm);
  text-decoration: none;
  transition: color var(--duration-base) var(--ease-out);
  word-break: break-all;
}
.site-footer__email:hover { color: var(--color-primary); }

/* Bottom bar */
.site-footer__bottom {
  border-top: 1px solid var(--color-bg-dark);
  padding: var(--space-6) 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-2);
  font-size: var(--text-xs);
  color: var(--color-text-400);
}
.heart { color: var(--color-primary); }

/* Responsive */
@media (max-width: 900px) {
  .site-footer__grid {
    grid-template-columns: 1fr 1fr;
    gap: var(--space-8);
  }
  .site-footer__brand { grid-column: 1 / 3; }
}
@media (max-width: 500px) {
  .site-footer__grid {
    grid-template-columns: 1fr;
  }
  .site-footer__brand { grid-column: 1; }
  .site-footer__bottom { flex-direction: column; text-align: center; }
}
</style>
